import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { CategoriaHipoModel } from 'src/app/models/categoria-hipo/CategoriaHipoModel';
import { FilterCategoriaHipoModel } from 'src/app/models/categoria-hipo/FilterCategoriaHipoModel';
import { ParametrosMaestro } from 'src/app/models/common/enumModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { ICategoriaHipoModel } from 'src/app/models/interfaces/categoria-hipo/ICategoriaHipoModel';
import { IFilterCategoriaHipoModel } from 'src/app/models/interfaces/categoria-hipo/IFilterCategoriaHipoModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { CategoriaHipoService } from 'src/app/services/categoria-hipo/categoria-hipo.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';

@Component({
  templateUrl: './configuracion-categoria-hipo-listar.component.html',
  styleUrls: ['./configuracion-categoria-hipo-listar.component.css']
})
export class ConfiguracionCategoriaHipoListarComponent implements OnInit {
  model!: SearchResultModel<ICategoriaHipoModel[]>;
  filter: IFilterCategoriaHipoModel = new FilterCategoriaHipoModel();
  listaEstados: ParametroModel[] = new Array<ParametroModel>();
  resultsLength = 0;
  currentPage = 0;

  displayedColumns: string[] = [
    'id',
    'nombre',
    'estado',
    'acciones'
  ];
  
  @ViewChild('paginator') paginator!: MatPaginator;

  constructor(
    private serviceCategoriaHipo: CategoriaHipoService,
    private serviceParametros: ParametroService
  ) { 
    this.model = new SearchResultModel<ICategoriaHipoModel[]>(false, new Array<CategoriaHipoModel>(), 0, 1, 0);
  }

  ngOnInit(): void {
    this.serviceParametros.getDetalles(ParametrosMaestro.ESTADO_CONFIG_MAESTRO).subscribe((data) => {
      this.listaEstados = data.items;
    });
    
    this.serviceCategoriaHipo.getListFiltered(this.filter).subscribe((data) => {
      this.model = data;
      this.resultsLength = data.total;
    });
  }

  search(): void{
    this.filter.page = 1;
    this.filter.pageSize = 30;
    this.serviceCategoriaHipo
      .getListFiltered(this.filter)
      .subscribe((data) => {
        this.model = data;
        this.resultsLength = data.total;
        this.currentPage = 0;
        this.paginator.firstPage();
      });
  }

  getPaginatorData(event: any) {
    this.filter.page = event.pageIndex + 1;
    this.filter.pageSize = event.pageSize;
    this.serviceCategoriaHipo
      .getListFiltered(this.filter)
      .subscribe((data) => {
        this.model = data;
        this.resultsLength = data.total;
      });
  }

}
